module.exports = __webpack_public_path__ + "static/media/accident.8c31cdbb.svg";